import axios from 'axios'
import { getCookie } from '@/pkg/cookie'   

let vsmsClient, vsmsRestClient
const token = getCookie('resource')

if (process.env.NODE_ENV === 'development') {
  vsmsClient = axios.create({
    baseURL: process.env.VUE_APP_API_VSMS_URL,
    headers: {Authorization: `Bearer ${token}`}
  })
  vsmsRestClient = axios.create({
    baseURL: process.env.VUE_APP_API_VSMS_REST_URL,
    headers: { Authorization: `Bearer ${token}` },
  })
} else {
  vsmsClient = axios.create({
    baseURL: process.env.VUE_APP_API_VSMS_URL,
    withCredentials: true,
  })
  vsmsRestClient = axios.create({
    baseURL: process.env.VUE_APP_API_VSMS_REST_URL,
    headers: { Authorization: `Bearer ${token}` },
  })
}

export function getVSMSClient() {
  return vsmsClient
}

export function getVSMSRestClient() {
  return vsmsRestClient
}